$('.js-contact-form').on('change', '.js-accept-marketing', function() {
  const $this = $(this);
  const $parent = $this.closest('form');
  const $customerForm = $('.js-customer-form');
  const $fieldAcceptMarketing = $customerForm.find('[name="customer[accepts_marketing]"]');

  $fieldAcceptMarketing.val($this.prop('checked'));
});
